import React from 'react';
import { Box } from '@chakra-ui/react';

export const InteractionProofLayer = () => {
  return <Box position="absolute" zIndex={9999999} top={0} bottom={0} right={0} left={0} />;
};
